module.exports = __webpack_public_path__ + "static/media/reward.fdc00667.jpg";